import type { SVGProps } from 'react';

const SvgTasks = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M9.29 5.29 6 8.58 4.71 7.29A.996.996 0 1 0 3.3 8.7l2 2c.2.2.45.29.71.29s.51-.1.71-.29l3.99-3.99A.996.996 0 1 0 9.3 5.3zM14 9h6c.55 0 1-.45 1-1s-.45-1-1-1h-6c-.55 0-1 .45-1 1s.45 1 1 1m-4.71 4.29L6 16.58l-1.29-1.29A.996.996 0 1 0 3.3 16.7l2 2c.2.2.45.29.71.29s.51-.1.71-.29l4-4a.996.996 0 1 0-1.41-1.41zM20 15h-6c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgTasks;
